import { render, staticRenderFns } from "./IncomingRedirect.vue?vue&type=template&id=2f90ec5e&scoped=true"
import script from "./IncomingRedirect.vue?vue&type=script&lang=ts"
export * from "./IncomingRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90ec5e",
  null
  
)

export default component.exports